import { AuthProviderIcon } from '@/components/auth/AuthProviderIcon';
import { loginMethodLabel } from '@/lib/enums';

/** Re-export for feature code — resolves provider from loginMethod and renders the brand icon. */
export { AuthProviderIcon as LoginProviderIcon, resolveAuthProvider } from '@/components/auth/AuthProviderIcon';

/** Icon + friendly label for table cells (CMP UserManagementScreen BaseCellWithIcon parity). */
export function LoginProviderCell({ loginMethod }: { loginMethod?: string | null }) {
  return (
    <span className="inline-flex items-center gap-2">
      <AuthProviderIcon loginMethod={loginMethod} />
      <span>{loginMethodLabel(loginMethod)}</span>
    </span>
  );
}
